<template>
    <div class="page">
        <div class="page-bd max">
            <div class="table-box pd-20">
                <div class="content">
                    <div class="detail_title">{{ $t('trans_record') }}</div>

                    <div v-for="(item, i) in list" :key="'record'+i">
                        <Row class="bill">
                            <Col span="7" class="label">{{ $t('编号') }}</Col>
                            <Col class="value">{{ item.bill_id }}</Col>
                        </Row>
                        <div class="otherCtn">
                            <Row class="other">
                                <Col span="7" class="label">{{ $t('name') }}</Col>
                                <Col class="value">{{ item.name }}</Col>
                            </Row>
                            <Row class="other">
                                <Col span="7" class="label">{{ $t('日期') }}</Col>
                                <Col class="value">{{ item.date }}</Col>
                            </Row>
                            <Row class="other">
                                <Col span="7" class="label">{{ $t('购买物品') }}</Col>
                                <Col class="value">{{ item.goods }}</Col>
                            </Row>
                            <Row class="other">
                                <Col span="7" class="label">{{ $t('金额') }}</Col>
                                <Col class="value">{{ item.amount }}</Col>
                            </Row>
                            <Row class="other">
                                <Col span="7" class="label">{{ $t('状态') }}</Col>
                                <Col class="value">{{ item.status }}</Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name:"",
        components:{
            
        },
        data:function(){
            return{
                list: [
                    { bill_id: '11111111111111', name: 'Benny', date: '1333-04-01', goods: '手办', amount: 120, status: 1 },
                    { bill_id: '22222222222222', name: 'Benny1', date: '1333-04-01', goods: '手办1', amount: 120, status: 2 },
                    { bill_id: '33333333333333', name: 'Benny2', date: '1333-04-01', goods: '手办2', amount: 120, status: 3 },
                ],
            }
        },
        activated:function(){
            
        },
        mounted: function(){
            
        },
        methods:{
            
        },
    }
</script>

<style scoped>
    .content{
        border: 1px solid #ddd;
    }
    .detail_title{
        font-size: 18px;
        padding: 10px 20px;
        font-weight: 600;
    }
    .otherCtn{
        padding: 4px 20px;
        background: #F0F0F0;;
    }
    .other{
        margin: 8px 0;
    }
    .bill{
        font-size: 14px;
        border-bottom: 2px solid #ddd;
        border-top: 2px solid #ddd;
        padding: 10px 20px;
    }
    .label{
        font-size: 14px;
    }
    .value{
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/teacher/profile/trans_reocrd.vue